var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "-8.094 -13.49 70.146 80.938"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "instagram_svg__a",
  x1: -5.809,
  x2: 1.754,
  y1: -5.804,
  y2: 1.753
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFD521"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "5%",
  stopColor: "#FFD521"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50.112%",
  stopColor: "#F50000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95%",
  stopColor: "#B900B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95.008%",
  stopColor: "#B900B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#B900B4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "instagram_svg__b",
  x1: 0.009,
  x2: 0.917,
  y1: 0.009,
  y2: 0.917
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFD521"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "5%",
  stopColor: "#FFD521"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50.112%",
  stopColor: "#F50000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95%",
  stopColor: "#B900B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95.008%",
  stopColor: "#B900B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#B900B4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "instagram_svg__c",
  x1: -0.456,
  x2: 1.313,
  y1: -0.456,
  y2: 1.313
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFD521"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "5%",
  stopColor: "#FFD521"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50.112%",
  stopColor: "#F50000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95%",
  stopColor: "#B900B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "95.008%",
  stopColor: "#B900B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#B900B4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#instagram_svg__a",
  id: "instagram_svg__d",
  x1: -37.631,
  x2: 11.367,
  y1: -37.545,
  y2: 11.412,
  gradientTransform: "scale(1.00041 .99959)",
  gradientUnits: "userSpaceOnUse"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#instagram_svg__b",
  id: "instagram_svg__e",
  x1: 0.487,
  x2: 49.505,
  y1: 0.536,
  y2: 49.554,
  gradientUnits: "userSpaceOnUse"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#instagram_svg__c",
  id: "instagram_svg__f",
  x1: -12.569,
  x2: 36.431,
  y1: -12.53,
  y2: 36.482,
  gradientTransform: "scale(.99988 1.00012)",
  gradientUnits: "userSpaceOnUse"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#instagram_svg__d)",
  d: "M6.487 3.292a3.24 3.24 0 1 1-6.482 0A3.24 3.24 0 0 1 3.247.057a3.24 3.24 0 0 1 3.24 3.235",
  transform: "matrix(1 0 0 -1 38.133 15.87)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#instagram_svg__e)",
  d: "M48.937 16.124c-.12-2.63-.56-4.06-.925-5.01-.49-1.258-1.076-2.158-2.025-3.102-.939-.944-1.839-1.528-3.098-2.013-.949-.371-2.384-.812-5.014-.938-2.844-.125-3.687-.152-10.899-.152-7.205 0-8.055.027-10.899.152-2.63.126-4.058.567-5.008.938-1.265.485-2.158 1.069-3.102 2.013-.951.944-1.536 1.844-2.02 3.103-.366.949-.812 2.378-.926 5.009-.138 2.844-.164 3.7-.164 10.897 0 7.212.026 8.062.164 10.906.114 2.63.56 4.058.926 5.016.484 1.257 1.069 2.152 2.02 3.096.944.942 1.837 1.528 3.102 2.018.95.372 2.378.807 5.008.932 2.844.126 3.694.158 10.899.158 7.212 0 8.055-.032 10.899-.158 2.63-.125 4.065-.56 5.014-.932 1.259-.49 2.159-1.076 3.098-2.018.949-.944 1.534-1.839 2.025-3.096.365-.958.805-2.386.925-5.016.132-2.844.164-3.694.164-10.906 0-7.197-.032-8.053-.164-10.897m4.858 22.024c-.132 2.875-.586 4.839-1.259 6.55-.685 1.774-1.604 3.278-3.108 4.782-1.497 1.497-3.001 2.416-4.776 3.11-1.717.666-3.675 1.125-6.55 1.25-2.877.139-3.795.164-11.126.164-7.324 0-8.25-.025-11.125-.164-2.87-.125-4.826-.584-6.551-1.25-1.768-.694-3.272-1.613-4.77-3.11-1.503-1.504-2.422-3.008-3.114-4.783-.667-1.71-1.12-3.674-1.259-6.549C.032 35.272 0 34.352 0 27.021c0-7.324.032-8.242.157-11.118.139-2.87.592-4.832 1.259-6.551.692-1.768 1.61-3.279 3.115-4.776C6.028 3.079 7.532 2.153 9.3 1.461 11.025.795 12.981.341 15.85.21 18.728.077 19.653.045 26.977.045c7.33 0 8.25.032 11.125.164s4.834.586 6.551 1.252c1.775.692 3.279 1.618 4.776 3.115 1.504 1.497 2.423 3.008 3.108 4.776.673 1.719 1.127 3.681 1.259 6.55.132 2.877.164 3.795.164 11.12 0 7.33-.032 8.25-.164 11.126",
  transform: "matrix(1 0 0 -1 0 54.004)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#instagram_svg__f)",
  d: "M13.91 4.97c-4.965 0-8.993 4.02-8.993 8.985 0 4.972 4.028 8.998 8.992 8.998 4.966 0 8.999-4.026 8.999-8.998 0-4.964-4.033-8.986-8.999-8.986m0 22.847c-7.653 0-13.85-6.21-13.85-13.862C.06 6.309 6.257.105 13.91.105c7.651 0 13.855 6.204 13.855 13.85 0 7.652-6.204 13.862-13.856 13.862",
  transform: "matrix(1 0 0 -1 13.067 40.937)"
}))));
export { SvgInstagram as ReactComponent };
export default __webpack_public_path__ + "fc0e8a3f4e1edb06d92ad35d819a3ecb.svg";